<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main>
          <div class="mainTitle">
            <div>
              <h3>相似字段扫描</h3>
              <el-button style="float: right" @click="reset()">重置</el-button>
            </div>
            <p>查找内容一样或相似的字段</p>
          </div>

          <div class="mainBody scanWord" v-show="showTables">
            <template>
              <div class="userData_style">
                <el-table :data="usersData" :show-header="false" @row-click="rowClickUserData" class="userData_table_style" highlight-current-row>
                  <el-table-column width="10">
                    <template slot-scope="scope">
                      <div v-bind:class="[usersData[scope.$index].merge == 1 ? 'userData_merge_1' : 'userData_merge_0']"></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="student_no" label="学号" align="center" min-width="2"></el-table-column>
                  <el-table-column prop="name_cn" label="姓名" min-width="1"></el-table-column>
                  <el-table-column prop="max_repeat_rate" label="占比" min-width="1"></el-table-column>
                </el-table>

                <el-pagination
                  class="elPagination"
                  background
                  small
                  layout="prev, pager, next"
                  :page-size="pageMaxSize"
                  :pager-count="7"
                  :page-count="pageCount"
                  @current-change="currentChange"
                  v-if="resetElPagination"
                ></el-pagination>
              </div>
              <div class="verticalBar"></div>
              <el-table :data="userInfoCount" v-show="showUserInfoCount" :show-header="false" :highlight-current-row="true" @row-click="rowClickUserInfoCount" style="width: 17%; float: left">
                <el-table-column prop="title" label="标题" align="center" min-width="1"></el-table-column>
                <el-table-column prop="count" label="数量" align="center" min-width="1"></el-table-column>
              </el-table>
              <div class="verticalBar"></div>

              <div class="c_tableTitle">
                <span>{{ tableTitle }}</span>
                <el-button size="mini" @click="verifyMerge()" style="float: right" v-show="showJob || showEducation || showHonor || showJournal">合并</el-button>
              </div>
              <el-table :data="ais_job_info" style="width: 62%; float: left" v-if="showJob" @selection-change="handleSelectionChange">
                <el-table-column type="selection" min-width="1" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="1"></el-table-column>
                <el-table-column prop="location" label="所在地" min-width="1"></el-table-column>
                <el-table-column prop="organization" label="单位名称" min-width="1"></el-table-column>
                <el-table-column prop="unit_property" label="单位性质" min-width="1"></el-table-column>
                <el-table-column prop="job_type" label="行业类型" min-width="1"></el-table-column>
                <el-table-column prop="position" label="工作职位" min-width="1"></el-table-column>
                <el-table-column prop="pay" label="薪酬范围" min-width="1"></el-table-column>
                <el-table-column prop="registered_address" label="公司注册地" min-width="1"></el-table-column>
                <el-table-column prop="employees" label="雇员人数" min-width="1"></el-table-column>
                <el-table-column prop="turnover" label="年营业额" min-width="1"></el-table-column>
                <el-table-column prop="freelance" label="从事何种自由职业" min-width="1"></el-table-column>

                <!-- <el-table-column
                  type="selection"
                  width="55"
                  align="center"
                ></el-table-column> -->
                <!-- <el-table-column prop="status" label="工作状态" min-width="1" align="center"></el-table-column> -->
                <!-- <el-table-column
                  prop="organization_city"
                  label="所在地"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="organization"
                  label="单位名称"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="unit_property"
                  label="单位性质"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="job_type"
                  label="行业类型"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="position"
                  label="职位"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="pay"
                  label="薪酬类型"
                  min-width="1"
                  align="center"
                ></el-table-column> -->
                <el-table-column label="操作" min-width="1" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="delJobInfo(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table :data="ais_education" style="width: 62%; float: left" v-if="showEducation" @selection-change="handleSelectionChange">
                <el-table-column type="selection" min-width="1" align="center"></el-table-column>
                <el-table-column prop="education_status" label="状态" min-width="1"></el-table-column>
                <el-table-column prop="location" label="所在地" min-width="1"></el-table-column>
                <el-table-column prop="education_school" label="院校名称" min-width="1"></el-table-column>
                <el-table-column prop="education_programme" label="院校专业" min-width="1"></el-table-column>
                <el-table-column prop="education_graduation_year" label="毕业年份" min-width="1"></el-table-column>
                <el-table-column prop="education_other" label="其他" min-width="1"></el-table-column>
                <!-- <el-table-column
                  prop="education_status"
                  label="深造状态"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="education_city"
                  label="所在地"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="education_school"
                  label="院校名称"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="education_programme"
                  label="专业"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="education_graduation_year"
                  label="毕业年份"
                  min-width="1"
                  align="center"
                ></el-table-column> -->
                <el-table-column label="操作" min-width="1" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="delEducationInfo(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table :data="ais_honor" style="width: 62%; float: left" v-if="showHonor" @selection-change="handleSelectionChange">
                <el-table-column type="selection" min-width="1" align="center"></el-table-column>
                <!-- <el-table-column
                  prop="honor_time"
                  label="时间"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="荣誉内容"
                  min-width="1"
                  align="center"
                ></el-table-column> -->
                <el-table-column prop="idshow" label="ID" min-width="1"></el-table-column>
                <el-table-column prop="honor_time" label="荣誉时间" min-width="1"></el-table-column>
                <el-table-column prop="content" label="荣誉内容" min-width="1"></el-table-column>
                <el-table-column label="操作" min-width="1" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="delHonorInfo(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table :data="ais_journal" style="width: 62%; float: left" v-if="showJournal" @selection-change="handleSelectionChange">
                <el-table-column type="selection" min-width="1" align="center"></el-table-column>
                <!-- <el-table-column
                  prop="journal_time"
                  label="时间"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="捐助内容"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="money"
                  label="捐助金额"
                  min-width="1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注"
                  min-width="1"
                  align="center"
                ></el-table-column> -->
                <el-table-column prop="idshow" label="ID" min-width="1"></el-table-column>
                <el-table-column prop="journal_time" label="捐助时间" min-width="1"></el-table-column>
                <el-table-column prop="content" label="捐助内容" min-width="1"></el-table-column>
                <el-table-column prop="money" label="捐助金额" min-width="1"></el-table-column>
                <el-table-column prop="type" label="捐助类型" min-width="1"></el-table-column>
                <el-table-column prop="remark" label="备注" min-width="1"></el-table-column>
                <el-table-column label="操作" min-width="1" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="delJournalInfo(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>

          <div class="scanrequire" v-show="changScanDialogVisible">
            <div class="body_scan">
              <div>
                <h2>按年级批量扫描</h2>
                <div class="scan_year">
                  <span>&emsp;入学年份&nbsp;&nbsp;</span>
                  <el-select class="input" v-model="whereYearInput" placeholder="请选择">
                    <el-option v-for="item in yearOptions" :key="item" :value="item"></el-option>
                  </el-select>
                </div>

                <div class="scanAccuracy">
                  <span>扫描准确度*&nbsp;</span>
                  <el-select class="input" v-model="whereRepeatInput" placeholder="请选择">
                    <el-option v-for="item in repeatOptions" :key="item" :value="item"></el-option>
                  </el-select>
                </div>

                <div class="scan_explain">
                  <p>*扫描准确度高，扫描出的数据少，速度慢，相似度高</p>
                  <p>扫描准确度低，扫描出的数据多，速度快，相似度偏低</p>
                </div>
              </div>

              <el-button class="scan_btn" size="small" type="primary" @click="startScan()">开始扫描</el-button>
            </div>
          </div>
        </el-main>
        <scan-dialog ref="_scanDialog" @toStopScan="$toStopScan" @toGetRepeatInfo="getRepeatInfo"></scan-dialog>
        <select-repeat-dialog ref="_selectRepeatDialog" @toSave="$toSaveEdit"></select-repeat-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from '@/components/layout/leftMeun'
import headerLayout from '@/components/layout/headerLayout'
import scanDialog from '@/components/dialog/scanDialog'
import selectRepeatDialog from '@/components/dialog/selectRepeatDialog'
import * as StrUtils from '@/utils/strUtils.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
var selectUser
var selectRepeat

export default {
  components: {
    leftMeun,
    headerLayout,
    scanDialog,
    selectRepeatDialog
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '相似字段扫描',
      showTables: false,
      showUserInfoCount: false,
      timeOutTimer: null,
      changScanDialogVisible: true,
      resetElPagination: true,
      pageCount: 0,
      pageMaxSize: 15,
      dataListPageIndex: 1,
      showJob: false,
      showEducation: false,
      showHonor: false,
      showJournal: false,
      ais_job_info: [],
      ais_education: [],
      ais_honor: [],
      ais_journal: [],
      usersData: [],
      userInfoCount: [],
      multipleSelection: [], // 多选容器
      tableTitle: '',

      whereYearInput: '',
      yearOptions: [], //入学年份
      whereRepeatInput: '', //重复率
      repeatOptions: [
        // "10%",
        // "20%",
        '30%',
        '40%',
        '50%',
        '60%',
        '70%',
        '80%',
        '90%'
      ] //重复率
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getYearOptions()
    },
    reset() {
      this.showTables = false
      this.changScanDialogVisible = true
      this.$refs._scanDialog.scanComplete()
      this.cleanInfoTable()
      this.whereYearInput = ''
      this.whereRepeatInput = ''
    },
    // 校友列表分页
    currentChange(val) {
      this.dataListPageIndex = val
      this.getRepeatInfo()
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.multipleSelection = selection
      // console.log(this.multipleSelection);
    },
    // 选中用户
    rowClickUserData(row, column, event) {
      // console.log(row);
      // console.log(column);
      // console.log(event);
      selectUser = row
      this.getUserInfoCount()
      this.cleanInfoTable()
    },
    //清空信息表格
    cleanInfoTable() {
      this.multipleSelection = []
      this.tableTitle = ''
      this.showJob = false
      this.showEducation = false
      this.showHonor = false
      this.showJournal = false
    },
    //选中各种信息
    rowClickUserInfoCount(row, column, event) {
      this.cleanInfoTable()
      this.tableTitle = row.title
      this.timeOutTimer = setTimeout(this.rowClickUserInfoCount_, 10)
    },
    rowClickUserInfoCount_() {
      switch (this.tableTitle) {
        case '工作信息':
          this.showJob = true
          this.getAisJobInfoById()
          break
        case '深造信息':
          this.showEducation = true
          this.getAisEducationById()
          break
        case '荣誉信息':
          this.showHonor = true
          this.getAisHonorById()
          break
        case '捐助信息':
          this.showJournal = true
          this.getAisJournalById()
          break
      }
    },
    // 获取校友重复字段列表
    getRepeatInfo() {
      this.$api
        .getRepeatInfo({
          token: localStorage.getItem('token'),
          year: this.whereYearInput,
          repeat: selectRepeat,
          page: this.dataListPageIndex,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          this.cleanInfoTable()
          this.showTables = true
          this.showUserInfoCount = false
          this.usersData = data.Data.model
          this.pageCount = data.Data.pageCount
          this.usersData.forEach(element => {
            console.log(element.merge)
            element.max_repeat_rate = parseInt(element.max_repeat_rate * 100) + '%'
          })
          // this.$nextTick(() => {
          //   this.$refs._scanDialog.scanComplete();
          // });
        })
        .catch(({ error }) => {})
    },
    getUserInfoCount() {
      this.$api
        .getUserInfoCount({
          token: localStorage.getItem('token'),
          id: selectUser.id
        })
        .then(({ data }) => {
          this.showUserInfoCount = true
          this.userInfoCount = [
            { title: '工作信息', count: '(' + data.Data.jobCount + ')' },
            { title: '深造信息', count: '(' + data.Data.educationCount + ')' },
            { title: '荣誉信息', count: '(' + data.Data.honorCount + ')' },
            { title: '捐助信息', count: '(' + data.Data.journalCount + ')' }
          ]
          console.log(data)
        })
        .catch(({ error }) => {})
    },
    // 获取工作信息
    getAisJobInfoById: function () {
      this.$api
        .getAisJobInfoById({
          token: localStorage.getItem('token'),
          id: selectUser.id
        })
        .then(({ data }) => {
          this.ais_job_info = data.Data
          this.ais_job_info.forEach(element => {
            element.location = StrUtils.getJobLocation(element)
          })
        })
        .catch(({ error }) => {})
    },
    // 获取深造信息
    getAisEducationById: function () {
      this.$api
        .getAisEducationById({
          token: localStorage.getItem('token'),
          id: selectUser.id
        })
        .then(({ data }) => {
          console.log(data)
          this.ais_education = data.Data
          this.ais_education.forEach(element => {
            element.location = StrUtils.getEduLocation(element)
          })
        })
        .catch(({ error }) => {})
    },
    // 获取捐助信息
    getAisJournalById: function () {
      this.$api
        .getAisJournalById({
          token: localStorage.getItem('token'),
          id: selectUser.id
        })
        .then(({ data }) => {
          this.ais_journal = data.Data
          this.ais_journal.forEach(element => {
            element.idshow = element.id.substring(element.id.length - 6, element.id.length)
          })
        })
        .catch(({ error }) => {})
    },
    // 获取荣誉信息
    getAisHonorById: function () {
      this.$api
        .getAisHonorById({
          token: localStorage.getItem('token'),
          id: selectUser.id
        })
        .then(({ data }) => {
          this.ais_honor = data.Data
          this.ais_honor.forEach(element => {
            element.idshow = element.id.substring(element.id.length - 6, element.id.length)
          })
        })
        .catch(({ error }) => {})
    },
    // 删除用户信息
    delJobInfo(index, row) {
      this.ais_job_info[index].delete_time = 1
      this.$api
        .updateInfoById({
          token: localStorage.getItem('token'),
          id: selectUser.id,
          update_time: selectUser.update_time,
          ais_job_info: JSON.stringify(this.ais_job_info)
        })
        .then(({ data }) => {
          if (data.Code == 0) {
            this.ais_job_info.splice(index, 1)
            this.userInfoCount[0].count = '(' + this.ais_job_info.length + ')'
            selectUser.update_time = data.Data.update_time
            this.updateUserTableUI()
          } else {
            this.$message.error(data.Msg)
          }
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    // 删除深造信息
    delEducationInfo(index, row) {
      this.ais_education[index].delete_time = 1
      this.$api
        .updateInfoById({
          token: localStorage.getItem('token'),
          id: selectUser.id,
          update_time: selectUser.update_time,
          ais_education: JSON.stringify(this.ais_education)
        })
        .then(({ data }) => {
          if (data.Code == 0) {
            this.ais_education.splice(index, 1)
            this.userInfoCount[1].count = '(' + this.ais_education.length + ')'
            selectUser.update_time = data.Data.update_time
            this.updateUserTableUI()
          } else {
            this.$message.error(data.Msg)
          }
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    // 删除荣誉信息
    delHonorInfo(index, row) {
      this.ais_honor[index].delete_time = 1
      this.$api
        .updateInfoById({
          token: localStorage.getItem('token'),
          id: selectUser.id,
          update_time: selectUser.update_time,
          ais_honor: JSON.stringify(this.ais_honor)
        })
        .then(({ data }) => {
          if (data.Code == 0) {
            this.ais_honor.splice(index, 1)
            this.userInfoCount[2].count = '(' + this.ais_honor.length + ')'
            selectUser.update_time = data.Data.update_time
            this.updateUserTableUI()
          } else {
            this.$message.error(data.Msg)
          }
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    // 删除捐助信息
    delJournalInfo(index, row) {
      this.ais_journal[index].delete_time = 1
      this.$api
        .updateInfoById({
          token: localStorage.getItem('token'),
          id: selectUser.id,
          update_time: selectUser.update_time,
          ais_journal: JSON.stringify(this.ais_journal)
        })
        .then(({ data }) => {
          if (data.Code == 0) {
            this.ais_journal.splice(index, 1)
            this.userInfoCount[3].count = '(' + this.ais_journal.length + ')'
            selectUser.update_time = data.Data.update_time
            this.updateUserTableUI()
          } else {
            this.$message.error(data.Msg)
          }
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    // 保存合并信息 修改
    $toSaveEdit(flag, updateData) {
      console.log(updateData)
      switch (flag) {
        case 'ais_education':
          this.$api
            .updateInfoById({
              token: localStorage.getItem('token'),
              id: selectUser.id,
              update_time: selectUser.update_time,
              ais_education: JSON.stringify(updateData)
            })
            .then(({ data }) => {
              if (data.Code == 0) {
                this.mergeDataSuc(data)
              } else {
                this.$message.error(data.Msg)
              }
            })
            .catch(({ error }) => {})
          break
        case 'ais_job_info':
          this.$api
            .updateInfoById({
              token: localStorage.getItem('token'),
              id: selectUser.id,
              update_time: selectUser.update_time,
              ais_job_info: JSON.stringify(updateData)
            })
            .then(({ data }) => {
              if (data.Code == 0) {
                this.mergeDataSuc(data)
              } else {
                this.$message.error(data.Msg)
              }
            })
            .catch(({ error }) => {})
          break
        case 'ais_journal':
          this.$api
            .updateInfoById({
              token: localStorage.getItem('token'),
              id: selectUser.id,
              update_time: selectUser.update_time,
              ais_journal: JSON.stringify(updateData)
            })
            .then(({ data }) => {
              if (data.Code == 0) {
                this.mergeDataSuc(data)
              } else {
                this.$message.error(data.Msg)
              }
            })
            .catch(({ error }) => {})
          break
        case 'ais_honor':
          this.$api
            .updateInfoById({
              token: localStorage.getItem('token'),
              id: selectUser.id,
              update_time: selectUser.update_time,
              ais_honor: JSON.stringify(updateData)
            })
            .then(({ data }) => {
              if (data.Code == 0) {
                this.mergeDataSuc(data)
              } else {
                this.$message.error(data.Msg)
              }
            })
            .catch(({ error }) => {})
          break
      }
    },
    // 更新用户列表UI
    updateUserTableUI() {
      selectUser.merge = 1
    },
    // 成功合并信息
    mergeDataSuc(data) {
      selectUser.update_time = data.Data.update_time
      this.rowClickUserInfoCount_()
      this.getUserInfoCount()
      this.updateUserTableUI()
    },
    // 验证合并
    verifyMerge() {
      Api.verifyApi(CApi.api_updateInfoById, verify => {
        if (verify) {
          this.merge()
        }
      })
    },
    // 合并字段
    merge() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先勾选合并信息')
        return
      }
      if (this.multipleSelection.length == 1) {
        this.$message.error('1条数据无法合并')
        return
      }
      var showFlag
      var allData
      if (this.showJob) {
        showFlag = 'ais_job_info'
        allData = this.ais_job_info
      } else if (this.showEducation) {
        showFlag = 'ais_education'
        allData = this.ais_education
      } else if (this.showHonor) {
        showFlag = 'ais_honor'
        allData = this.ais_honor
      } else if (this.showJournal) {
        showFlag = 'ais_journal'
        allData = this.ais_journal
      }
      this.$nextTick(() => {
        this.$refs._selectRepeatDialog.show(showFlag, allData, this.multipleSelection)
      })
    },
    beforeDestroy() {
      clearTimeout(this.timeOutTimer)
    },
    // 获取入学年份
    getYearOptions: function () {
      this.$api
        .getColumnValue({
          token: localStorage.getItem('token'),
          field: 'year'
        })
        .then(({ data }) => {
          this.yearOptions = data.Data.year
          this.whereYearInput = this.yearOptions[0]
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    // 开始扫描
    startScan() {
      if (this.whereRepeatInput == '') {
        this.$message.error('请选择扫描准确度')
        return
      }
      selectRepeat = parseFloat(this.whereRepeatInput) / 100
      this.updateRepeatRate()
    },
    // 更新重复率
    updateRepeatRate() {
      this.$api
        .updateRepeatRate({
          token: localStorage.getItem('token'),
          year: this.whereYearInput
        })
        .then(({ data }) => {
          var repeatId = data.Data.repeatId
          this.changScanDialogVisible = false
          this.$nextTick(() => {
            this.$refs._scanDialog.init(repeatId)
          })
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    $toStopScan() {
      console.log('-------------取消扫描')
      this.changScanDialogVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.c_tableTitle {
  margin: 20px;
}
.mainBody {
  overflow: hidden;
  margin-top: 10px;
  // padding: 0px 30px 15px 0px;
  background-color: #ffffff;
  border-radius: 5px;
}
.userData_style {
  width: 20%;
  float: left;
}
.userData_table_style {
  width: 100%;
  float: left;
}
.verticalBar {
  float: left;
  width: 1px;
  height: 780px;
  background: #c4c4c4;
}
.elPagination {
  margin-top: 30px;
  float: left;
}
.userData_merge_0 {
  width: 5px;
  height: 23px;
  background-color: #f2c94c;
}
.userData_merge_1 {
  width: 5px;
  height: 23px;
  background-color: #27ae60;
}
.scanrequire {
  margin-top: 10px;
  // padding: 0px 30px 15px 0px;
  padding-top: 15vh;
  background-color: #ffffff;
  border-radius: 5px;
  height: 65vh;
  // position: relative;
}
.body_scan {
  width: 600px;
  // height: 300px;
  // position: absolute;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // top: -150px;
  margin: auto;
}
.body_scan h2 {
  margin-left: 40px;
}
// 入学年份
.scan_year {
  margin-top: 50px;
  margin-left: 40px;
}
// 扫描准确度
.scanAccuracy {
  margin-top: 40px;
  margin-left: 40px;
}
// 扫描说明
.scan_explain {
  margin-top: 60px;
  margin-left: 40px;
}
.scan_explain p {
  font-size: 12px;
}
.scan_btn {
  margin-left: 40px;
  margin-top: 50px;
  width: 106px;
}
</style>

<style lang="less">
.scanWord .el-table__body,
.scanWord .el-table__footer,
.scanWord .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}

.scanWord .el-table .cell,
.scanWord .el-table th div,
.scanWord .el-table--border td:first-child .cell,
.scanWord .el-table--border th:first-child .cell {
  padding-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/scanWord.vue